import { render } from "./SystemEvent.vue?vue&type=template&id=3de0ebec"
import script from "./SystemEvent.vue?vue&type=script&lang=js"
export * from "./SystemEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__